import Table from "../../components/Table";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiFinancialsList } from "../../api/financialApi";
import { styled } from "@mui/material";
import SnippetFolderIcon from "@mui/icons-material/SnippetFolder";

import { ExportContainer, Item, StyledListItemIcon } from "components/Table/ExportBotton";
import { StyledListItemText } from "components/Reports/components";
import { apiGetCheques } from "api/chequeApi";
import axios from "../../axios/axios";
import { getQueryParam, setQueryParam, setQueryParams } from "helpers/queryParam";
import { errorDispatcher, getOptionsQuery, lowerFirst } from "helpers";
import { store } from "store/store";
import { appSetLoading } from "store/actions/appAction";
import fileDownload from "js-file-download";
import { DateToString } from "components/Reports/DateFilter";
const UpperSection = styled("div")(({ theme }) => ({
    display: "flex",
    flexWrap: "wrap",
    gap: 20,
    alignItems: "center",
    width: "100%",
    marginBottom: "10px",
}));
export default function Cheques({ type }) {
    const { getState, dispatch } = store
    const token = getState().businessReducer.business?.token;
    const UpperSide = () => {
        const downloadExcel = () => {

            const chequeType = getQueryParam("type") || type
            let status = getQueryParam("status") || 'all'
            if (chequeType) {
                let slicePosition = chequeType === "receive" ? 15 : 14;
                status = typeof status === "string" ? lowerFirst(status.slice(slicePosition)) : null;

                let url = `/cheques/list?chequeType=${chequeType}`;

                let data = { excel: true }
                if (status === "expired") {
                    url += "&statusColumn=dueDate";
                    url += "&statusText=" + moment().format("jYYYY/jM/jD");
                } else if (status !== "all" && status !== null) {
                    url += "&statusColumn=status";
                    url += "&statusText=" + status;
                }
                const tokenHeader = { Authorization: `Bearer ${token}` };
                axios
                    .post(url, data, {
                        headers: { ...tokenHeader },
                        responseType: "blob",
                    })
                    .then((response) => {
                        const now = DateToString(Date.now()).replace("/", "_");
                        fileDownload(response.data, `cheque${chequeType}${now}.xlsx`);
                    })
                    .catch((error) => {
                        errorDispatcher(error, dispatch);
                    }).finally(() => dispatch(appSetLoading(false)))
            }
        }
        return (
            <UpperSection>
                <ExportContainer>
                    <Item disableRipple onClick={() => {
                        downloadExcel()
                    }}>
                        <StyledListItemIcon>
                            <SnippetFolderIcon color="success" />
                        </StyledListItemIcon>
                        <StyledListItemText sx={{ minWidth: '5rem' }}> دانلود اکسل </StyledListItemText>
                    </Item>
                </ExportContainer>
            </UpperSection>
        )
    }

    const pagination = getState().paginationReducer

    useEffect(() => {
        dispatch(apiFinancialsList("bank", token));
        dispatch(apiFinancialsList("fund", token));
        dispatch(apiFinancialsList("cashier", token));
        setQueryParams([{ key: "status", value: "all" }, { key: "type", value: type === "receivedCheques" ? "receive" : "payment" }])
        // dispatch(apiGetCheques({ token, pagination, search: {}, sort: {} }))

    }, [type]);

    return <Table onTabChange={(tab) => {

        setQueryParams([{ key: "status", value: tab.activeTab.key }, { key: "type", value: tab.activeTab.type }])

        dispatch(apiGetCheques({ token, pagination, search: {}, sort: {} }))

    }}
        key={type} MidComponent={UpperSide} type={type} sumAmountInfo={[{ name: "amount", isCurrency: true }]} />;
}
